<template>
  <div>
    <!-- 複数もぎりができる商材であれば、枚数選択のダイアログ表示 -->
    <DialogSelectMultiValidFramesCount
      ref="DialogSelectMultiValidFramesCount"
      @childMethod="decideCountOfMultiSheetValid"
    />

    <TemplateSheetEmergencyCode :multiSheetValidIdsArray="multiSheetValidIds" />
  </div>
</template>

<script>
import TemplateSheetEmergencyCode from "@/views/Templates/MyTickets/TemplateSheetEmergencyCode";

import sheetService from "@/services/sheet";
import nativeHandlerService from "@/services/nativeHandler";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
  components: {
    TemplateSheetEmergencyCode: TemplateSheetEmergencyCode,
  },

  setup() {
    const store = useStore();
    const route = useRoute();

    // 複数有効化商材の時に枚数選択ダイアログの表示を管理するフラグ
    // 有効化される予定のフレームを配列で持つ
    let multiSheetValidIds = ref(null);
    
    // 枚数選択ダイアログ
    const DialogSelectMultiValidFramesCount = ref(null);

    const book = computed(() => store.getters["ticketing/book"]);

    onMounted(async () => {
      try {
        // Storeにbook情報がなければ、シートフローの中で必要なAPIを取得し、それぞれのデータをstoreへcommit
        if (book.value.length == 0) {
          await sheetService.getSheetInfomations(route);
        }
        console.log(
          "book.value.master_limits[0].max_concurrent_punching :>> ",
          book.value.master_limits[0].max_concurrent_punching
        );
        // 複数有効化可能であれば、初期表示で枚数選択ダイアログ表示
        if (book.value.master_limits[0].max_concurrent_punching > 1) {
          DialogSelectMultiValidFramesCount.value.openDialog();
        }
      } catch (err) {
        nativeHandlerService.ncSendTicketingError(
          "SheetEmergencyCode onMounted()",
          JSON.stringify(err)
        );
      }
    });

    // 枚数選択ダイアログで選択された枚数のフレームが引数
    const decideCountOfMultiSheetValid = (frames) => {
      console.log("decideCountOfMultiSheetValid :>> ", frames);
      multiSheetValidIds.value = frames;
    };

    return {
      multiSheetValidIds,
      decideCountOfMultiSheetValid,
      DialogSelectMultiValidFramesCount,
    };
  },
};
</script>
